import React from 'react'

const ImageCard = ({ image }) => {
  const tags = image.tags.split(',')
  return (
    <div className='p-4 md:w-1/3'>
      <div className='h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden'>
        <img
          className='lg:h-48 md:h-36 w-full object-cover object-center'
          src={image.webformatURL}
          alt='demo'
        />
        <div className='p-6'>
          <h2 className='tracking-widest text-xs title-font font-medium text-gray-400 mb-1'>
            Photo by {image.user}
          </h2>
          <h1 className='title-font text-lg font-medium text-gray-900 mb-3'>
            <strong>Downloads: </strong> {image.views}
          </h1>
          <p className='leading-relaxed mb-3'>
            <strong>Views: </strong> {image.likes}
          </p>
        </div>
        <div className='px-6 py-4'>
          {tags.map((tag, index) => (
            <span
              key={index}
              className='bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2'
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ImageCard
